import { ColorPickerV2 } from '@bynder/design-system';
import type { Color, ColorStop, SolidColor } from 'packages/ds/ColorPicker/types';

export type PickerValue = ColorPickerV2.ColorWithAlpha | ColorPickerV2.Gradient<ColorPickerV2.ColorWithAlpha>;

const FULL_OPACITY = 100;

function toColorWithAlpha(color: SolidColor): ColorPickerV2.ColorWithAlpha {
    return typeof color === 'string' ? { color, opacity: FULL_OPACITY } : color;
}

/**
 * `ColorPickerV2` pins one color shape across solids and gradient stops, so a bare hex
 * string has to be widened to `{ color, opacity }` in both positions.
 */
export function toPickerValue(value: Color): PickerValue {
    if (typeof value === 'object' && 'type' in value) {
        // DS types stops as a two-or-more tuple; ours is a plain array.
        return {
            ...value,
            stops: value.stops.map((stop: ColorStop) => ({ ...stop, color: toColorWithAlpha(stop.color) })),
        } as PickerValue;
    }

    return toColorWithAlpha(value);
}
